/* Copyright (c) 2023-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Component, Input, ViewContainerRef } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FlexModule } from '@angular/flex-layout/flex';
import { TranslateModule } from '@ngx-translate/core';
import {
    HigProgressCircularDefaultDiameter,
    HigProgressCircularMode,
    HigProgressCircularTvDiameter
} from './nv-hig-progress';

@Component({
    selector: 'nv-hig-progress-circular',
    templateUrl: './nv-hig-progress-circular.component.html',
    styleUrls: ['./nv-hig-progress-circular.component.scss'],
    imports: [FlexModule, MatProgressSpinnerModule, TranslateModule]
})
export class NvHigProgressCircularComponent {
    @Input() isTv = false;
    @Input() mode = HigProgressCircularMode.Indeterminate;
    @Input() value = 0;
    @Input() diameter = this.isTv ? HigProgressCircularTvDiameter : HigProgressCircularDefaultDiameter;

    constructor(public viewRef: ViewContainerRef) {}
}
